module.exports = __webpack_public_path__ + "possibleNegotiation.png";